import React, { Component } from "react";

// Router
import { withRouter } from "react-router-dom";

// SCSS
import "./ShoveberryLevelLayoutHeader.scss";

// Icons & Images
import BlackCrossIcon from "static/assets/shoveberry/images/black-cross-icon.svg";
import CircularBlackCrossIcon from "static/assets/shoveberry/images/circular-black-cross-icon.svg";
import CircularLevelsIcon from "static/assets/shoveberry/images/circular-levels-icon.svg";

// Helper Functions
import { getFormattedNumber } from "utils/helperFunctions";

// Components
import ShoveberryModal from "components/Shoveberry/ShoveberryModal";

class ShoveberryLevelLayoutHeader extends Component {
  state = {
    minutes: 15,
    seconds: 0,
    // isTimeOut: false,
    isCta: false,
    isMobile: false,
  };

  componentDidMount() {
    if (window && window.innerWidth < 1023) {
      this.setState({
        isMobile: true,
      });
    }
    this.myInterval = setInterval(() => {
      const { seconds, minutes } = this.state;
      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
        localStorage.setItem("seconds", this.state.seconds);
      }
      if (seconds === 30) {
        this.setState({ isCta: true });
      }
      if (seconds === 0) {
        if (minutes === 0) {
          // this.setState({ isTimeOut: true })
          this.props.showTimeOutModal(true);
          clearInterval(this.myInterval);
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
          localStorage.setItem("minutes", this.state.minutes);
        }
      }
    }, 1000);
  }

  render() {
    const { minutes, seconds, isMobile } = this.state;

    const {
      currentLevel,
      onShowLevelModalClick,
      showTimeOutModal,
    } = this.props;

    return (
      <>
        <div className="shoveberry-level-layout-header-component">
          <div
            className="shoveberry-level-layout-header-component__left-container"
            onClick={() => this.props.history.push("/")}
          >
            {!isMobile ? (
              <>
                <img src={BlackCrossIcon} alt="cross icon" /> Exit
              </>
            ) : (
              <img src={CircularBlackCrossIcon} alt="Cross icon" />
            )}
          </div>
          <div className="shoveberry-level-layout-header-component__timer">
            <p className="shoveberry-level-layout-header-component__timer--level-text">
              LEVEL {currentLevel}
            </p>
            {getFormattedNumber(minutes)}:{getFormattedNumber(seconds)}
          </div>
          {!isMobile ? (
            <p className="shoveberry-level-layout-header-component__level-text">
              Levels
            </p>
          ) : (
            <img
              src={CircularLevelsIcon}
              alt="Level Selector icon"
              onClick={onShowLevelModalClick}
            />
          )}
          {/* TODO: Handle this */}
          {/* {this.state.isTimeOut
            &&
            <ShoveberryModal
              overlayColor='#ff6262'
              thumbnail=''
              title='Oops!'
              timeTaken='4:30'
              totalMoves='30'
              subTitle='You did better than 43% players'
            />
          } */}
        </div>
      </>
    );
  }
}
export default withRouter(ShoveberryLevelLayoutHeader);
